export const config = {
    VANTAGE_API_URL: "https://plusleadinfoapi-staging.azurewebsites.net",
  };
  
  export async function loadConfig() {
    try {
      const response = await fetch("/config.json");
      if (!response.ok) throw new Error("Failed to fetch config.json");
  
      const json = await response.json();
      console.log("Loaded config:", json);
  
      // Update the config dynamically
      Object.assign(config, json);
    } catch (error) {
      console.error("Error loading config.json. Using fallback.", error);
    }
  }
  